import { Button, Buttons, CancelButton, Icon, ModalCard } from '~/components';
import { saveAs } from 'file-saver';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { colors } from '~/styles';

const WarningList = styled.ul`
  margin-top: 0.5rem;
  margin-bottom: 1rem;
  list-style: disc inside;
`;

export default function XeroExportDialog({ onLoad, onClose }) {
  const [reportFile, setReportFile] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await onLoad;
        setReportFile(data);
      } catch (error) {
        setReportFile({ statusId: 'failed' });
      }
    })();
  }, [onLoad]);

  const handleClose = async () => {
    onClose();
  };

  return (
    <ModalCard title="Download Report" onClose={handleClose}>
      <ModalCard.Body>
        {(() => {
          switch (reportFile?.statusId) {
            case 'completed':
              return <p>Your file is now ready to download.</p>;

            case 'failed':
              return (
                <p>
                  <Icon icon="exclamation-circle" color={colors.danger} /> There was a problem getting your file, please
                  try again later.
                </p>
              );

            default:
              return <p>Your report export is being created.</p>;
          }
        })()}
        <div style={{ marginTop: '2rem' }}>Before importing this file into Xero, make sure to:</div>
        <WarningList>
          <li>Ensure contact names match exactly between Xero and Ruddr.</li>
          <li>
            Verify Xero item names match your Ruddr invoice items, and their General Ledger Codes match the assigned
            Account codes (e.g., 200).
          </li>
          <li>Confirm tax rates names match your Ruddr invoice tax rates. (e.g., 'Tax on Sales')</li>
        </WarningList>
      </ModalCard.Body>
      <ModalCard.Footer>
        <Buttons align="right">
          <CancelButton onClick={handleClose}>Close</CancelButton>

          <Button
            isLoading={!reportFile || ['pending', 'processing'].includes(reportFile?.statusId)}
            disabled={reportFile?.statusId !== 'completed'}
            onClick={() => {
              saveAs(reportFile.url, reportFile.name);
            }}>
            Download
          </Button>
        </Buttons>
      </ModalCard.Footer>
    </ModalCard>
  );
}
